import Vue from 'vue'
import Router from 'vue-router'
import NProgressBar from '../helpers/nprogress-bar'

Vue.use(Router)

const LoginPage = () => import(/* webpackChunkName: "LoginPage" */ '@/pages/Login.vue')
const ReportUserPage = () => import(/* webpackChunkName: "ReportUsersPage" */ '@/pages/Report-users.vue')
const MapPage = () => import(/* webpackChunkName: "MapPage" */ '@/pages/Maps.vue')
const ReportPage = () => import(/* webpackChunkName: "ReportPage" */ '@/pages/Reports.vue')
const ErrorPage = () => import(/* webpackChunkName: "ErrorPage" */ '@/pages/page_helper/PageError.vue')

export const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: LoginPage
    },
    {
      path: '/users',
      name: 'report-users',
      component: ReportUserPage
    },
    {
      path: '/map',
      name: 'Map',
      component: MapPage
    },
    {
      path: '*',
      name: 'PageError',
      component: ErrorPage
    },
    {
      path: '/',
      name: 'Reports',
      component: ReportPage
    }
  ]
})

NProgressBar(router)
export default router



// WEBPACK FOOTER //
// ./src/router/index.js